// Generated from src/passportRegistry.ts; see scripts/passport-ecosystem-contracts.cjs.
import definitions from "./src/passportKinds.json";
export const passportKinds = definitions;
export function isPassportKind(value) {
    return (typeof value === "string" &&
        Object.prototype.hasOwnProperty.call(definitions, value));
}
export function passportKind(value) {
    return isPassportKind(value) ? definitions[value] : null;
}
export function publicCardFacts(kind, facts) {
    const adapter = passportKind(kind);
    if (!adapter || !facts)
        return [];
    return adapter.fields.flatMap((key) => {
        const v = facts[key];
        if (typeof v !== "string" && typeof v !== "number")
            return [];
        if (typeof v === "number" && !Number.isFinite(v))
            return [];
        return String(v).trim() ? [{ key, value: String(v) }] : [];
    });
}
/** API timestamps are UTC; the event's published zone controls its calendar date. */
export function passportEventDate(value, zone, withTime = false) {
    if (!value)
        return '';
    const timestamp = /^\d{4}-\d\d-\d\d[ T]\d\d:\d\d/.test(value) && !/(Z|[+-]\d\d:\d\d)$/.test(value) ? value.replace(' ', 'T') + 'Z' : value;
    const date = new Date(timestamp);
    if (!Number.isFinite(date.getTime()))
        return value;
    try {
        return new Intl.DateTimeFormat('en-US', { timeZone: zone || 'UTC', year: 'numeric', month: 'short', day: 'numeric', ...(withTime ? { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' } : {}) }).format(date);
    }
    catch {
        return value;
    }
}
